import {Component} from '@angular/core';
import {TableBaseComponent} from "@pages/table.base.component";
import {FilterChangedEvent, SelectionColumnDef} from "@ag-grid-community/core";
import {EventType} from "@data/interefaces/event.type.interface";
import {ActivatedRoute} from "@angular/router";
import {EventTypeService} from "@data/event/event-type.service";
import {pageContext, tableColumns} from "@pages/event-type/event-type.component.ds";
import {AgGridService} from "@shared/services/ag-grid.service";

@Component({
  selector: 'app-event-type',
  templateUrl: './event-type.component.html',
  styleUrls: ['./event-type.component.scss'],
  providers: [AgGridService]
})
export class EventTypeComponent extends TableBaseComponent {
  rowData: EventType[] = [];
  refreshComplete: boolean = true;
  protected override tableColumns = tableColumns;
  protected override pageContext = pageContext;

  constructor(private _activatedRoute: ActivatedRoute, private _eventTypeService: EventTypeService) {
    super();
  }

  public override ngOnInit() {
    super.ngOnInit();
    this.initiatePageState(this._activatedRoute.snapshot.queryParamMap);
    this.refreshView();
  }

  refreshView() {
    this.refreshComplete = false;
    this.displayProgressBar(true);
    this._eventTypeService.getEventTypes()
      .then(results => this.rowData = results)
      .catch(error => this.displayNotificationMessage('error', JSON.stringify(error)))
      .finally(() => {
        this.refreshComplete = true;
        this.displayProgressBar(false)
      });
  }

  onFilterChanged(event: FilterChangedEvent<any>) {
    const updateLiveDataFilter = this.isUpdateLiveDataFilterRequired(event.columns);
    this._agGridService.processOnFilterChanged(event, this.pageContext, this.updatePageContext.bind(this)).then(() => {
      if (updateLiveDataFilter) {
        this.onLiveDataFilterChange(true);
      }
    });
  }

  onLiveDataFilterChange(forceReload: boolean = false): void {
    if (forceReload) {
      this.refreshView();
    }
    this.updateToPageContextUrl();
  }

  protected override updatePageContext(updateContextUrl: boolean): void {
  }

  protected override getSelectionColumnDef(): SelectionColumnDef {
    return {};
  }
}
